module.exports = {
      id: "cancel-usage",
      viewBox: "0 0 241.171 241.171",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#cancel",
      toString: function () {
        return this.url;
      }
    }